<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    width="28"
    height="28"
  >
    <path
      fill="#3F3F3F"
      d="M18 5.5a4.5 4.5 0 1 1-9 0a4.5 4.5 0 0 1 9 0m-2.854-1.854L12.5 6.293l-.646-.647a.5.5 0 0 0-.708.708l1 1a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708M8.022 5H6a2 2 0 0 0-2 2v4h3.5a.5.5 0 0 1 .5.5v.011l.004.06a2.6 2.6 0 0 0 .256.955c.126.254.308.492.572.667c.26.174.63.307 1.168.307s.907-.133 1.168-.307c.264-.175.446-.413.572-.667a2.6 2.6 0 0 0 .26-1.015V11.5a.5.5 0 0 1 .5-.499H16v-.6a5.5 5.5 0 0 0 1-.657V15a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h2.207a5.5 5.5 0 0 0-.185 1m-.971 7H4v3a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-3h-3.05a3.6 3.6 0 0 1-.315.974a2.7 2.7 0 0 1-.912 1.051c-.443.295-1.01.475-1.723.475c-.712 0-1.28-.18-1.723-.475a2.7 2.7 0 0 1-.912-1.051A3.6 3.6 0 0 1 7.051 12"
    />
  </svg>
</template>
